import { AfterContentInit, Component, OnInit } from '@angular/core';
import { LoadingService } from '@wz-services';

@Component({
  selector: 'wz-oups',
  templateUrl: './oups.component.html',
  styleUrls: ['./oups.component.scss'],
  standalone: false,
})
export class OupsComponent implements OnInit, AfterContentInit {
  loading: boolean = false;

  constructor(private loadingService: LoadingService) {}

  ngOnInit() {}

  ngAfterContentInit() {
    this.loadingService.loadingSubject.next(false);
  }
}
